import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { CheckCircleFill, CloseCircleFill, ExclamationCircleFill, InformationCircleFill } from 'antd-mobile-icons'
import { merchantCompleteCallback } from '../api/merchantApplyService'

type VerificationStatus = 'loading' | 'success' | 'failed' | 'error'

export default function MerchantCompleteCallback() {
  const [searchParams] = useSearchParams()
  const applicationId = searchParams.get('applicationId') || ''
  const [status, setStatus] = useState<VerificationStatus>('loading')
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    if (applicationId === '') {
      setStatus('error')
      setMessage('参数错误，请重新完善信息')
      return
    }

    const verifyCallback = async () => {
      try {
        const isSuccess = await merchantCompleteCallback(applicationId)
        if (isSuccess) {
          setStatus('success')
          setMessage('信息完善成功，感谢配合！可关闭网页，返回 App 继续推广和提现。')
        } else {
          setStatus('failed')
          setMessage('认证失败，请重新完善信息')
        }
      } catch (error) {
        setStatus('error')
        setMessage('系统错误，请稍后重试')
      }
    }

    verifyCallback()
  }, [applicationId])

  const renderContent = () => {
    switch (status) {
      case 'loading':
        return (
          <div className="space-y-3">
            <div className="mx-auto w-16 h-16 rounded-full border-4 border-[#E5E7EB] border-t-[#3A55DD] animate-spin" />
            <div className="text-gray-700 text-base font-semibold">正在核验认证结果...</div>
            <div className="text-xs text-gray-500">请稍候，正在同步人脸识别结果</div>
          </div>
        )
      case 'success':
        return (
          <div className="flex flex-col items-center space-y-2">
            <div className="w-14 h-14 rounded-full bg-[#ECFDF3] flex items-center justify-center shadow-inner">
              <CheckCircleFill className="text-[#10B981] text-4xl" />
            </div>
            <span className="text-[#0F172A] text-lg font-semibold">认证成功</span>
            <span className="text-gray-500 text-sm">{message}</span>
            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2">
              <InformationCircleFill className="text-blue-500 flex-shrink-0 mt-0.5" />
              <span className="text-sm text-blue-700 text-left">返回 App 后，请重新进入当前页面以查看最新状态。</span>
            </div>
          </div>
        )
      case 'failed':
        return (
          <div className="flex flex-col items-center space-y-2">
            <div className="w-14 h-14 rounded-full bg-[#FEF2F2] flex items-center justify-center shadow-inner">
              <CloseCircleFill className="text-[#EF4444] text-4xl" />
            </div>
            <span className="text-[#0F172A] text-lg font-semibold">认证失败</span>
            <span className="text-gray-500 text-sm">{message}</span>
          </div>
        )
      case 'error':
        return (
          <div className="flex flex-col items-center space-y-2">
            <div className="w-14 h-14 rounded-full bg-[#FFF7ED] flex items-center justify-center shadow-inner">
              <ExclamationCircleFill className="text-[#F59E0B] text-4xl" />
            </div>
            <span className="text-[#0F172A] text-lg font-semibold">出现错误</span>
            <span className="text-gray-500 text-sm">{message}</span>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl border border-[#E5E7EB] p-8">
          <div className="flex items-center justify-between mb-4">
            <span className="px-3 py-1 rounded-full bg-[#EEF2FF] text-[#22357D] text-xs font-semibold">资料完善</span>
            <span className="text-[12px] text-gray-500">安全加密 · 实时结果</span>
          </div>
          <div className="text-center space-y-2 mb-6">
            <h2 className="text-xl font-bold text-[#0F172A]">身份复核结果</h2>
            <p className="text-sm text-gray-500">继续按提示处理，确保合规与收益结算</p>
          </div>
          <div className="text-center">{renderContent()}</div>
        </div>
      </div>
    </div>
  )
}
